import styled from "styled-components";

export const FormGroup = styled.div`
    flex: 1;
    min-width: 0;
`;